import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import coderGuy from "../../Assets/coder-guy-figure.png";
import Home2 from "./Home2";
import Type from "./Type";

function Home() {
  return (
    <section className="page-transition">
      <Container fluid className="home-section" id="home">
        <Container className="home-content">
          <Row>
            <Col md={5} style={{ paddingBottom: 20 }}>
              <img
                src={coderGuy}
                alt="coder guy figure"
                className="img-fluid developer-avatar"
                style={{ maxHeight: "450px" }}
              />
            </Col>

            <Col md={7} className="home-header">
              <h1 style={{ paddingBottom: 15 }} className="heading">
                Hi There!{" "}
                <span className="wave" role="img" aria-labelledby="wave">
                  👋🏻
                </span>
              </h1>

              <h1 className="heading-name">
                I'M
                <strong className="main-name"> MELİH ÖZCAN</strong>
              </h1>

              <div style={{ padding: 50, textAlign: "left" }}>
                <Type />
              </div>
            </Col>
          </Row>
        </Container>
      </Container>
      <Home2 />
    </section>
  );
}

export default Home;
